export enum FlightCommonTrackingRawEventName {
  EnteredFlight = "EnteredFlight",
}
